import axios from '../../utils/axios'
import { errorHandler } from '../../utils/apiFunctions'
import queryString from 'query-string'

const baseRoute = '/reports'

export const get = (queryParams, filterData) => dispatch =>
    axios.post(baseRoute + `?${queryString.stringify(queryParams)}`, { filterData })
        .then(response => Promise.resolve(response.data))
        .catch(errorHandler)